import { Box, ListItemText, MenuItem, MenuList } from '@mui/material';
import isEqual from 'lodash/isEqual';
import { Count, useStore } from 'react-admin';

interface StatusFilter {
  key: string;
  label: string;
  filter: Record<string, string>;
}

export const userInvitationStatusFilters: StatusFilter[] = [
  { filter: {}, key: 'ALL', label: 'Všetky' },
  { filter: { status: 'ACCEPTED' }, key: 'ACCEPTED', label: 'Prijaté' },
  { filter: { status: 'CANCELLED' }, key: 'PENDIGN', label: 'Zrušené' },
  { filter: { status: 'PENDING' }, key: 'ALL', label: 'Čakajúce' },
];

export const UserInvitationListAside: React.FC = () => {
  const [statusFilter, setStatusFilter] = useStore(
    'resources.userInvitations.list.statusFilter',
    userInvitationStatusFilters[0].filter,
  );

  return (
    <Box flexShrink={0} mr={1} mt={7} order={-1} width={200}>
      <MenuList>
        {userInvitationStatusFilters.map((it) => (
          <MenuItem key={it.key} onClick={() => setStatusFilter(it.filter)} selected={isEqual(statusFilter, it.filter)}>
            <ListItemText>{it.label}</ListItemText>
            <Count color="text.disabled" filter={it.filter} />
          </MenuItem>
        ))}
      </MenuList>
    </Box>
  );
};
